import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Repeat from '@mui/icons-material/Repeat';
import ContentCut from '@mui/icons-material/ContentCut';
import { planTimeline } from '../image_utilities/Timeline';
import { imageShape } from '../shapes/ImageShapes';

const CompositionModeDialog = ({ open, images, onChoose }) => (
  <Dialog open={open} maxWidth="sm" fullWidth aria-labelledby="composition-mode-title"
    aria-describedby="composition-mode-description" className="composition-dialog">
    <DialogTitle id="composition-mode-title">How should these images play together?</DialogTitle>
    <DialogContent>
      <p id="composition-mode-description" className="composition-intro">
        Choose how their lengths fit. Both keep the original speed.
      </p>
      <div className="composition-choices">
        {['repeat', 'truncate'].map(mode => {
          const plan = planTimeline(images, { compositionMode: mode });
          const repeat = mode === 'repeat';
          const onlyStills = plan.tracks.every(track => track.isStatic);
          return <Button key={mode} aria-label={repeat ? 'Repeat' : 'Truncate'}
            className="composition-choice" variant="outlined" onClick={() => onChoose(mode)}>
            <span className="composition-choice-heading">
              {repeat ? <Repeat /> : <ContentCut />}
              <strong>{repeat ? 'Repeat' : 'Truncate'}</strong>
            </span>
            <span className="composition-choice-duration">
              {plan.error ? 'Over 120 s' : `${Number((plan.duration / 1000).toFixed(2))} s`}
              <small>output</small>
            </span>
            <span className="composition-choice-description">{onlyStills ? 'Still images stay visible together.' : repeat
              ? 'Loop each animation until they finish together.'
              : 'End together when the shortest animation finishes.'}</span>
            <span className="composition-choice-note">{onlyStills ? 'Both modes give the same result for still images.' : repeat
              ? 'This overrides saved play counts.' : 'Longer animations are cut short.'}</span>
            {plan.error && <span className="composition-choice-note">Choose a shorter duration in Output settings.</span>}
          </Button>;
        })}
      </div>
      <p className="composition-footer">Change this anytime beside the timeline. Still images stay visible in either mode.</p>
    </DialogContent>
  </Dialog>
);

CompositionModeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  images: PropTypes.arrayOf(imageShape).isRequired,
  onChoose: PropTypes.func.isRequired,
};

export default CompositionModeDialog;
